<template>
    <div>
        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">
                员工档案信息
                <el-button
                    style="float: right; height: 40px; margin-top: -10px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                    @click="Return()">返回</el-button>
            </div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

                    <el-row style="margin-top: 40px;">
                        <el-col :span="3">
                            <img :src="from.staff_photo" style="float: right;" width="117px" height="143px" />
                        </el-col>
                        <el-col :span="20" style="margin-left: 20px; margin-top: 15px;">
                            <h3 style="font-weight: 600; font-size: 21px; color: #000000;">{{from.staff_name}}</h3>
                            <h4 style="font-weight: 300; color: #556567;">
                                {{from.organize_name}}&nbsp;&nbsp;{{from.post_name}}
                            </h4>
                        </el-col>
                    </el-row>

                    <el-button
                        style="float: right; height: 40px; margin-top: 0px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                        @click="Update" v-show="!is_edit">修改</el-button>
                    <div style="float: right;">
                        <el-button
                            style="height: 40px; margin-top: 0px; margin-right: 10px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Save" v-show="is_edit">保存</el-button>
                        <el-button
                            style="height: 40px; margin-top: 0px; margin-right: 40px; background-color: #FFFFFF; color: #006E4B; border: 1px solid #006E4B;"
                            @click="Cancel" v-show="is_edit">取消</el-button>
                    </div>
                    <el-row style="margin-top: 50px;">
                        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

                            <el-tab-pane label="基本信息" name="basic">
                                <basic ref="basic" :from="from" v-show="!is_edit"></basic>
                                <basicEdit ref="basicEdit" :from="from" v-show="is_edit"></basicEdit>
                            </el-tab-pane>

                            <el-tab-pane label="工作信息" name="work">
                                <work ref="work" :from="from" v-show="!is_edit"></work>
                                <workEdit ref="workEdit" :from="from" v-show="is_edit"></workEdit>
                            </el-tab-pane>

                            <el-tab-pane label="保险信息" name="insurance">
                                <insurance ref="insurance" :from="from" v-show="!is_edit"></insurance>
                                <insuranceEdit ref="insuranceEdit" :from="from" v-show="is_edit"></insuranceEdit>
                            </el-tab-pane>

                            <el-tab-pane label="附件信息" name="accessory">
                                <accessory ref="accessory" :from="from" v-show="!is_edit"></accessory>
                                <accessoryEdit ref="accessoryEdit" :from="from" v-show="is_edit"></accessoryEdit>
                            </el-tab-pane>

                        </el-tabs>
                    </el-row>
                </div>
            </el-row>
        </div>

    </div>
</template>

<script>
    import axios from "axios";
    import basic from "./tabs/basic.vue";
    import work from "./tabs/work.vue";
    import insurance from "./tabs/insurance.vue";
    import accessory from "./tabs/accessory.vue";
    import basicEdit from "./tabsEdit/basic.vue";
    import workEdit from "./tabsEdit/work.vue";
    import insuranceEdit from "./tabsEdit/insurance.vue";
    import accessoryEdit from "./tabsEdit/accessory.vue";

    export default {
        components: {
            basic: basic,
            work: work,
            insurance: insurance,
            accessory: accessory,
            basicEdit: basicEdit,
            workEdit: workEdit,
            insuranceEdit: insuranceEdit,
            accessoryEdit: accessoryEdit,
        },
        data() {
            return {
                //页面相关
                activeName: "basic",

                is_edit: false,

                from: {}

            };
        },
        methods: {
            //返回
            Return() {
                this.$parent.Return();
            },
            //查询详情
            async Find() {
                var record = {
                    id: this.$parent.from.id,
                }
                var data = await this.$globals.AxiosPost("staff/detailsFind", record);
                this.from = data.data;
            },
            //修改
            Update() {
                this.is_edit = true;
            },
            //取消
            Cancel() {
                this.is_edit = false;
                this.Find();
            },
            //保存
            async Save() {
                var flag1 = true;
                var flag2 = true;
                var flag3 = true;
                var flag4 = true;
                this.$refs["basicEdit"].$refs["ruleForm"].validate(valid => {
                    flag1 = valid;
                });
                this.$refs["workEdit"].$refs["ruleForm"].validate(valid => {
                    flag2 = valid;
                });
                this.$refs["insuranceEdit"].$refs["ruleForm"].validate(valid => {
                    flag3 = valid;
                });
                this.$refs["accessoryEdit"].$refs["ruleForm"].validate(valid => {
                    flag4 = valid;
                });
                if (flag1 && flag2 && flag3 && flag4) {
                    var url = "staff/updateStaffInformation";
                    var record = {
                        id: this.$parent.from.id,
                        staff_name: this.from.staff_name,
                        staff_gender: this.from.staff_gender,
                        staff_card: this.from.staff_card,
                        birth_date: this.from.birth_date,
                        age: this.from.age,
                        staff_telephone: this.from.staff_telephone,
                        nation: this.from.nation,
                        native_place: this.from.native_place,
                        card_address: this.from.card_address,
                        residence: this.from.residence,
                        domicile_place: this.from.domicile_place,
                        household_register_id: this.from.household_register_id,
                        bank_no: this.from.bank_no,
                        first_degree_id: this.from.first_degree_id,
                        second_degree_id: this.from.second_degree_id,
                        health_id: this.from.health_id,
                        mailbox: this.from.mailbox,
                        we_chat: this.from.we_chat,
                        entry_type_id: this.from.entry_type_id,
                        recruitment_method_id: this.from.recruitment_method_id,
                        induction_time: this.from.induction_time,
                        induction_salary: this.from.induction_salary,
                        probation_period: this.from.probation_period,
                        post_id: this.from.post_id,
                        pay_grade: this.from.pay_grade,
                        rank: this.from.rank,
                        is_part_time_job: this.from.is_part_time_job,
                        social_security_no: this.from.social_security_no,
                        medical_insurance_no: this.from.medical_insurance_no,
                        insured_begin_date: this.from.insured_begin_date,
                        insured_city: this.from.insured_city,
                        payment_type: this.from.payment_type,
                        is_accumulation_fund: this.from.is_accumulation_fund,
                        accumulation_fund_no: this.from.accumulation_fund_no,
                        provident_fund_base:this.from.provident_fund_base,
                        payment_account:this.from.payment_account,
                        insurance_type_ids:this.from.insurance_type_ids,
                        five_risks_account:this.from.five_risks_account,
                        aged_three_insurance:this.from.aged_three_insurance,
                        birth_insurance:this.from.birth_insurance,
                        spare5:this.from.spare5,
                        is_insurance_medical:this.from.is_insurance_medical,
                        amount_making_difference:this.from.amount_making_difference,
                        variance_makeup_date:this.from.variance_makeup_date,
                        opening_bank:this.from.opening_bank,
                    };
                    var data = await this.$globals.AxiosPost(url, record);
                    if (data === '-2000') {
                        this.$message.error('服务器未响应！请稍后重试');
                    } else {
                        var code = data.code;
                        var data = data.data;
                        if (code === '200') {
                            this.Cancel();
                        } else {
                            this.$message.warning(data);
                        }
                    }
                }
            }
        },
        created() {
            this.Find();
        }
    }
</script>

<style scoped="scoped">
    >>>.el-tabs__item.is-active {
        color: #00724e !important;
        background-color: #FFFFFF;
        font-size: 16px;
        font-weight: 600;
        border-top: 3px solid #00704C;
        width: 25%;
        text-align: center;
        border-bottom: none;
    }

    >>>.el-tabs__item:hover {
        color: #00724e !important;
        background-color: #FFFFFF;
    }

    >>>.el-tabs__nav-scroll {
        background-color: #fbfbfb;
    }

    >>>.el-tabs__item {
        font-size: 16px;
        font-weight: 600;
        width: 25%;
        text-align: center;
    }

    >>>.el-tabs__nav {
        width: 600px;
    }
</style>



// WEBPACK FOOTER //
// Ygdaxx_edit.vue?6de6361b